<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <EventHeader :event="event" />
      <CardComponent>
        <h1 class="title">Manage Invite Links/Voucher Codes</h1>
        <div class="columns">
          <div class="column has-text-centered">
            <h5 class="is-size-5 has-text-weight-bold is-uppercase">Total</h5>
            <h3 class="is-size-3 has-text-weight-bold">{{ items.length }}</h3>
          </div>
          <div class="column has-text-centered">
            <h5 class="is-size-5 has-text-weight-bold is-uppercase">Left</h5>
            <h3 class="is-size-3 has-text-weight-bold">
              {{ items.length - totalclaimed() - totalexpired() }}
            </h3>
          </div>
          <div class="column has-text-centered">
            <h5 class="is-size-5 has-text-weight-bold is-uppercase">Claimed</h5>
            <h3 class="is-size-3 has-text-weight-bold">{{ totalclaimed() }}</h3>
          </div>
          <div class="column has-text-centered">
            <h3 class="is-size-5 has-text-weight-bold is-uppercase">Expired</h3>
            <h2 class="is-size-3 has-text-weight-bold">{{ totalexpired() }}</h2>
          </div>
        </div>
        <div>
          <b-button
            :disabled="loading"
            class="has-margin-right-10"
            type="is-primary"
            :loading="loading"
            @click="showAddVoucherCodesModal = true"
            >Add</b-button
          >
          <b-button
            :disabled="loading"
            class="has-margin-right-10"
            type="is-primary"
            :loading="loading"
            @click="exportCodes"
            >Export</b-button
          >
        </div>
        <b-table
          class="has-margin-top-15"
          :data="items"
          :paginated="true"
          :narrowed="true"
          :hoverable="true"
          :mobile-cards="true"
        >
          <template slot-scope="props">
            <b-table-column label="Code" field="code" :sortable="true">
              {{ props.row.code }}
            </b-table-column>
            <b-table-column label="Link" field="code" :sortable="true">
              <a :href="getCodeLink(props.row.code)">Link</a>
            </b-table-column>
            <b-table-column label="Claimed" field="claimed" :sortable="true">
              <b-icon
                v-if="props.row.claimed"
                class="has-text-success"
                icon="check"
              ></b-icon>
              <b-icon
                v-if="!props.row.claimed"
                class="has-text-danger"
                icon="close"
              ></b-icon>
              <div v-if="props.row.claimed">
                {{ props.row.dateclaimed | formatDateTime }}
              </div>
            </b-table-column>
            <b-table-column
              label="Expiry Date"
              field="expirydate"
              :sortable="true"
            >
              {{ props.row.expirydate | formatDateTime }}
            </b-table-column>
            <b-table-column label="Prepaid" field="prepaid" :sortable="true">
              <b-icon
                v-if="props.row.prepaid"
                class="has-text-success"
                icon="check"
              ></b-icon>
              <b-icon
                v-if="!props.row.prepaid"
                class="has-text-danger"
                icon="close"
              ></b-icon>
            </b-table-column>
            <b-table-column
              label="Discount"
              field="discountamount"
              :sortable="true"
            >
              {{
                props.row.discounttype == 'Percentage'
                  ? props.row.discountamount + '%'
                  : props.row.discountamount
              }}
            </b-table-column>
            <b-table-column label="" class="has-text-right">
              <b-button
                type="is-dark"
                class="has-margin-left-10"
                @click="remove(props.row)"
              >
                Delete
              </b-button>
            </b-table-column>
          </template>
        </b-table>
      </CardComponent>
    </section>
    <b-modal :active.sync="showAddVoucherCodesModal" scroll="keep">
      <AddVoucherCodes
        :event="$route.params.eventid"
        @refresh="loadData()"
      ></AddVoucherCodes>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Filters from '@/mixins/filters'
import EventHeader from '@/components/EventHeader'
import CardComponent from '@/components/CardComponent'
import AddVoucherCodes from '@/components/AddVoucherCodes'
import VoucherApi from '@/api/voucher'

export default {
  name: 'ManageWaitingList',
  components: {
    CardComponent,
    EventHeader,
    AddVoucherCodes,
  },
  mixins: [Filters],
  data() {
    return {
      items: [],
      search: '',
      initialized: false,
      loading: false,
      showAddVoucherCodesModal: false,
    }
  },
  computed: {
    ...mapGetters(['event']),
  },
  async created() {
    await this.loadData()
    this.initialized = true
  },
  methods: {
    async loadData() {
      this.items = await VoucherApi.getAll(this.$route.params.eventid)
    },
    getCodeLink(code) {
      return `https://capturefit.com/app-v2/special-invite/${this.$route.params.eventid}/${code}`
    },
    async exportCodes() {
      await VoucherApi.export(this.$route.params.eventid)
    },
    remove(row) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this voucher code?',
        onConfirm: async () => {
          await VoucherApi.remove(row)
          this.items = this.items.filter((item) => item._id !== row._id)
          this.$buefy.toast.open({
            message: 'Voucher code deleted.',
            position: 'is-top',
            type: 'is-success',
          })
        },
      })
    },
    expired(expirydate) {
      return new Date(expirydate) < new Date()
    },

    totalclaimed() {
      if (!this.items) {
        return 0
      }
      return this.items.filter((item) => item.claimed).length
    },

    totalexpired() {
      if (!this.items) {
        return 0
      }
      return this.items.filter(
        (item) =>
          !item.claimed &&
          item.expirydate &&
          new Date(item.expirydate) < new Date()
      ).length
    },
  },
}
</script>
